import React, { useEffect } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { AdditionalDriver } from '../../../models/booking/AdditionalDriver';
import { useBookingContext } from '../BookingContext';

const createDriver = (firstName = '', lastName = '', email = ''): AdditionalDriver => ({
  firstName,
  lastName,
  email
});

const DriversSection: React.FC = () => {
  const { booking, updateBooking } = useBookingContext();
  const { user } = useAuth();
  const totalSimulators = booking.fullMotionSimulators + booking.esportsSimulators;

  useEffect(() => {
    const currentLength = booking.additionalDrivers.length;
    if (currentLength === totalSimulators) {
      return;
    }

    const nextDrivers = booking.additionalDrivers.slice();
    if (nextDrivers.length === 0) {
      nextDrivers.push(createDriver(user?.firstName || '', user?.lastName || '', user?.email || ''));
    }

    while (nextDrivers.length < totalSimulators) {
      nextDrivers.push(createDriver());
    }
    if (nextDrivers.length > totalSimulators) {
      nextDrivers.length = totalSimulators;
    }

    updateBooking({ additionalDrivers: nextDrivers });
  }, [booking.additionalDrivers, totalSimulators, updateBooking, user?.email, user?.firstName, user?.lastName]);

  const updateDriver = (indexToUpdate: number, key: keyof AdditionalDriver, value: string) => {
    updateBooking({
      additionalDrivers: booking.additionalDrivers.map((driver, index) =>
        index === indexToUpdate ? { ...driver, [key]: value } : driver
      )
    });
  };

  return (
    <div className="d-flex flex-column gap-1">
      <label className="settings-field-label">Add driver's information:</label>
      {booking.additionalDrivers.length === 0 ? (
        <p className="text-paragraphs">No additional drivers added.</p>
      ) : (
        <div className="d-flex flex-column gap-2">
          {booking.additionalDrivers.map((driver, index) => (
            <div key={index} className="card">
              <div className="card-body">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <span className="text-white fw-semibold">Driver {index + 1}</span>
                  <span className="badge bg-primary">
                    {index < booking.fullMotionSimulators ? 'Full Motion simulator' : 'Esports simulator'}
                  </span>
                </div>
                <div className="row g-2">
                  <div className="col-md-4">
                    <input
                      className="form-control"
                      placeholder="First name (required)"
                      value={driver.firstName}
                      required
                      onChange={(e) => updateDriver(index, 'firstName', e.target.value)}
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      className="form-control"
                      placeholder={index === 0 ? 'Last name (required)' : 'Last name'}
                      value={driver.lastName}
                      required={index === 0}
                      onChange={(e) => updateDriver(index, 'lastName', e.target.value)}
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      type="email"
                      className="form-control"
                      placeholder={index === 0 ? 'Email (required)' : 'Email'}
                      value={driver.email}
                      required={index === 0}
                      onChange={(e) => updateDriver(index, 'email', e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DriversSection;
